<template>
    <!-- 生美Q4纳新激励排行榜 -->
    <div class="ranking">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
            <div v-for="(v, k) in jobTabs" :key="k">
                <div v-if="currentJobTab == k + 1">
                    <!-- banner -->
                    <img class="banner" :src="`${v.url}2025-10-15/${v.bannerImg}.png`" alt="banner">
                    <!-- 奖品 -->
                    <div class="reward-box">
                        <div v-if="currentJobTab === '2'">
                            <div class="bear-palm">
                                <p>获奖奖品</p>
                                <div>激励对象：生美主任 </div>
                                <div class="reward-bot">激励机制：
                                    <p>全力冲刺C1-C2新客达标（销售金额大于0），
                                        按纳新目标100%达成后，按实际达成率高者
                                        胜，如遇达成率重复，按纳新人数首购累计销
                                        售额高者为胜</p>
                                </div>
                                <div>达成率前10名</div>
                                <div class="red">{{ getTheme('prize') }}</div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="bear-palm bear-palm-img">
                                <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-15/prize.png" alt="right">
                            </div>
                        </div>

                        <p class="update-time">数据更新时间 {{ list && list[0] && list[0].etlTime }}</p>
                    </div>

                    <div class="bg-color"></div>
                </div>
            </div>
            <div class="ranking-box">
                <div class="tabs-box">
                    <div class="job-tabs">
                        <div>
                            <div class="job-tab-item" v-for="(it, ind) in jobTabs" :key="ind" :class="{ on: currentJobTab == it.dictValue }" @click="onJobTab(it)">
                                {{ it.dictLabel }}
                            </div>
                        </div>
                        <div class="group-tabs" v-if="currentJobTab === '2'">
                            <div class="group-tab-item" :class="{ on: currentGroupTab == j }" v-for="(j, n) in groupTabs" :key="n" @click="onGroupTab(j)">
                                {{ j }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ranking-list-box">
                    <div class="myWrapper" v-if="myData.employeeId">
                        <RankingItem :currentJobTab="currentJobTab" isMe :list="[myData]" :currentGroupTab="currentGroupTab" />
                    </div>
                    <div class="ranking-list-item title">
                        <div class="ranking-num">排名</div>
                        <div class="ranking-name">{{ jobTabs[currentJobTab - 1].title1 }}</div>
                        <div class="ranking-order">{{ jobTabs[currentJobTab - 1].title2 }}</div>
                        <div class="ranking-bonus">{{ jobTabs[currentJobTab - 1].title3 }}</div>
                    </div>
                    <RankingItem :currentJobTab="currentJobTab" :list="list" :currentGroupTab="currentGroupTab" :dataInfo="dataInfo" />
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import RankingItem from './rankingItem.vue'
    import { debounce } from 'lodash';
    import { ActionSheet, Toast } from 'vant'

    export default {
        name: 'ssRankList',
        components: {
            RankingItem,
            [ActionSheet.name]: ActionSheet
        },
        computed: {

            // showReword() {
            //     // 未达标且没有我的数据
            //     if (this.currentJobTab == 1 && (!this.dataInfo.cspPk && this.dataInfo.head === '未达标')) {
            //         return false
            //     } else {
            //         return true
            //     }
            // }
        },
        data() {
            return {
                showRule: false, // 是否显示规则弹窗
                jobTabs: [
                    {
                        dictLabel: 'Q4生美纳新激励', dictValue: '1'
                    },
                    {
                        dictLabel: '美田直营纳新激励', dictValue: '2',
                        groupTabs: ['第一组', '第二组', '第三组', '第四组'],
                    }], // 职位分类标签列表
                currentJobTab: '1',
                groupTabs: ['第一组', '第二组', '第三组', '第四组'], // 分组标签列表
                currentGroupTab: '第一组', // 当前选中的分组
                loading: false, // 是否正在加载
                currentMoldTab: '', // 当前选中第三层分组
                finished: false, // 是否加载完成
                list: [], // 排名列表数据
                isStore: 0, // 当前选中的tab
                page: 1, // 当前页码
                error: false, // 是否发生错误
                themeArr: [
                    {
                        "bgColor": "#FFE68F",
                        "url": "https://staticwecom.beautyfarm.com.cn/wecom-workbench/",
                        "bannerImg": "bannerQ4",
                        "title1": "姓名",
                        "title2": "客户人数 ",
                        "title3": "奖励美美币"
                    },
                    {
                        "bgColor": "#8B020F",
                        "url": "https://staticwecom.beautyfarm.com.cn/wecom-workbench/",
                        "bannerImg": "bannerSz",
                        "title1": "姓名",
                        "title2": "纳新人数达成率 ",
                        "title3": "奖品"
                    }
                ],
                groupNoList: 0,
                dataInfo: {},
                myData: {},
                storeId: '',
                empid: ''
            }
        },
        mounted() {
            const newArr = this.jobTabs.map((item, index) => {
                return { ...item, ...this.themeArr[index] }
            })
            this.jobTabs = newArr
            this.getUserLogin()
        },
        methods: {
            //查分组
            getCustflowMyDataGroup() {
                return request({
                    url: "octoberRank/getCcStoreNxMotivateGroup",
                    method: "get",
                    params: { storeId: this.storeId, employee_id: this.empid },//'944825'/371
                })
                    .then((res) => {
                        this.currentGroupTab = res.data.myData && res.data.myData.storeGroup || '第一组'
                        this.getDataList()
                    })
                    .catch((error) => {
                        Toast({ position: "top", message: error ?? "" });
                    });
            },
            //员工基本信息
            getUserLogin() {
                return request({
                    url: "/my/getUserLogin",
                    method: "get",
                })
                    .then((res) => {
                        this.storeId = res.data.storeId;
                        this.empid = res.data.empNo
                        if (this.currentJobTab === '1') {
                            this.getDataList()
                        } else {
                            this.getCustflowMyDataGroup()
                        }

                    })
                    .catch((error) => {
                        Toast({ position: "top", message: error ?? "" });
                    });
            },
            // 初始化数据，获取销售列表
            getDataList: debounce(async function () {
                if (this.finished) return
                Toast.loading({
                    forbidClick: true,
                    duration: 0
                });
                try {
                    let getUrl = this.currentJobTab === '1' ? '/octoberRank/getCcEmployeeNxMotivate' : '/octoberRank/getCcStoreNxMotivate'
                    const params = {
                        groupNo: this.currentJobTab === '1' ? '' : this.currentGroupTab,
                        pageNum: this.page,
                        employee_id: this.empid,//944825
                        storeId: this.storeId,//371
                        pageSize: 10
                    }
                    const { code, msg, data } = await request({
                        url: getUrl,
                        method: 'get',
                        params
                    })
                    if (code !== 0) {
                        throw new Error(msg)
                    }
                    Toast.clear();
                    // 对应jobTabs中的dataInfo赋值
                    this.dataInfo = data
                    this.myData = data.myData
                    // 对赌激励取cspPkList ，销售纳新取cspMmbList
                    const list = data && data.saleList
                    if (this.page == 1) {
                        this.list = list
                    } else {
                        this.list = this.list.concat(list)
                    }
                    this.page += 1
                    this.loading = false;

                    if (list.length < 10) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                    this.error = true;
                    this.$toast(error)
                }

            }, 500),
            onLoad() {
                this.getDataList()
            },
            // 切换职位分类标签
            onJobTab(value) {
                this.currentJobTab = value.dictValue;
                this.page = 1
                this.finished = false
                this.error = false;
                this.getCustflowMyDataGroup()
            },
            // 获取获奖文字
            getTheme(type) {
                const index = this.jobTabs[Number(this.currentJobTab) - 1].groupTabs.findIndex(it => it === this.currentGroupTab);
                const theme = {
                    prize: ['至尊童颜*1次（22800元/次）', '富贵童颜*1次（价值12580元/次）', '青春童颜*1次（价值8800元/次）', '韩版嘭弹水光*1（价值6800元/次）']
                }
                return theme[type][index];
            },
            // 切换分组标签
            onGroupTab(v) {
                this.currentGroupTab = v;
                this.finished = false
                this.error = false;
                this.page = 1
                this.getDataList()
            },
            toRule() {
                this.$router.push({ path: '/ssRankListRules', query: { currentJobTab: this.currentJobTab } })
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking {
        position: relative;
        height: 100%;
        font-size: 28px;
        overflow-y: scroll;
        color: #333333;
        background-color: #fff;
    }

    .mmbMum-box {
        margin: 40px 0;
        display: flex;
        margin-bottom: 60px;

        div {
            flex: 1;
            text-align: center;

            p:nth-child(1) {
                font-size: 24px;
                color: #333333;
                margin-bottom: 30px;
            }

            p:nth-child(2) {
                font-size: 46px;
                color: #D62C18;

                span {
                    font-size: 30px;
                }
            }
        }

        .avtive-top-38 {
            p:nth-child(2) {
                color: #0072FF;
            }
        }


    }

    .myWrapper {
        padding: 20px;
    }

    .banner {
        width: 100%;
        height: 464px;
    }

    .rule {
        position: absolute;
        width: 120px;
        top: 50px;
        right: 0;
        height: 61px;
        line-height: 61px;
        font-size: 26px;
        text-align: center;
        color: #ffffff;
        background: #D22E28;
        border-top-left-radius: 31px;
        border-bottom-left-radius: 31px;
        // padding: 10px 0;
    }

    .rule1,
    .rule2 {
        background: #DBC7C1;
    }

    .rule3 {
        background: #DBC7C1;
    }

    .reward-box {
        position: relative;
        width: 100%;
        margin-top: -94px;
        padding: 30px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        z-index: 9;

        .reward-status {
            width: 100%;
            // margin-bottom: 30px;
        }

        .achieving-rate {
            font-size: 24px;
            color: #333333;
            margin: 40px 0;

            p {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            span {
                font-size: 46px;
                color: #D62C18;
            }
        }

        .bear-palm {
            width: 100%;
            background: #F9F5F0;
            border-radius: 50px;
            padding: 0 63px;
            font-size: 26px;
            color: #333333;
            padding-bottom: 45px;

            >p {
                width: 325px;
                height: 70px;
                background: linear-gradient(84deg, #DCC7C1, #D4C7C2);
                border-radius: 0px 0px 40px 40px;
                margin: 0 auto;
                text-align: center;
                font-weight: bold;
                font-size: 36px;
                color: #FFFFFF;
                line-height: 70px;
                text-shadow: 1px 3px 0px rgba(60, 0, 94, 0.52);
                margin-bottom: 36px;
            }

            img {
                width: 100%;
            }

            div:nth-child(2) {
                margin-bottom: 10px;
                text-align: left;
                font-size: 24px;
                color: #666666;
            }

            div:nth-child(3) {
                margin-bottom: 50px;
                text-align: left;
                font-size: 24px;
                color: #666666;
            }

            div:nth-child(4) {
                font-size: 26px;
                margin-bottom: 10px;
            }

            div:nth-child(5) {
                font-size: 26px;

            }

            .red {
                color: #D62C18;
            }

            .reward-bot {
                margin-bottom: 30px !important;
                display: flex;

                p {
                    width: calc(100% - 120px);
                }
            }

            .reward-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;

                .reward-left {
                    font-size: 26px;
                    width: 330px;
                    text-align: center;

                    p {
                        margin-bottom: 10px;
                    }

                    span {
                        margin-left: 10px;
                        font-size: 30px;
                        color: #D41D16;
                    }
                }

                .reward-right {
                    width: 170px;
                    text-align: center;
                }

                img {
                    width: 136px;
                }
            }

            .mask {
                img {
                    width: 167px;
                }
            }

            .reward-top1 {
                .reward-left {
                    p:nth-child(2) {
                        font-size: 30px;
                        color: #D41D16;
                    }
                }

                img {
                    width: 97px;
                }
            }


        }

        .bear-palm-img {
            background: transparent;
            padding: 0;
        }
    }

    .reward {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 349px;
        // padding-bottom: 30px;
        // padding-top: 80px;
        margin-bottom: 30px;
        // background-image: url('https://staticwecom.beautyfarm.com.cn/wecom-workbench/20250618/bg.png');
        background-size: 100% 100%;

        // &.left {
        //     padding-right: 30px;
        //     padding-left: 20px;
        // }
        >div {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .horizantalBox {
            padding: 80px 108px 30px 108px;
        }

        .columnBox {
            align-items: flex-end;
        }

        .reward-data {
            flex-grow: 1;
            flex-shrink: 0;
            text-align: center;
            width: 50%;

            >img {
                height: 150px;
            }

            >div {
                font-size: 36px;
            }

            .fontRed {
                color: #D41D16;
                font-size: 42px;
                font-weight: bold;
            }

            &:first-of-type {
                width: 60%;
            }
        }

        .reward-data-column {

            >div {
                font-size: 36px;
                padding-top: 10px;
            }

            .fontRed {
                color: #D41D16;
                font-size: 42px;
                font-weight: bold;
            }

            img {
                height: 150px;
                vertical-align: sub;
                padding-left: 75px;
            }
        }


    }

    .reward1 {
        height: 439px;
    }

    .reward2 {
        height: 439px;
    }

    .compare {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0;

        .less {
            width: 40px;
            height: 40px;
        }

        .compare-data {
            width: 45%;

            p {
                margin-bottom: 10px;
            }

            p:first-child {
                font-size: 36px;
            }

            p:nth-child(2) {
                font-size: 24px;
            }

            p:last-child {
                font-size: 46px;
                font-weight: 500;
            }
        }
    }

    .update-time {
        font-size: 24px;
        color: #999999;
        margin-top: 20px;
    }

    .fs-32 {
        font-size: 32px;
    }

    .blue {
        color: #007AFF;
        font-weight: 500;
    }

    .ranking-box {
        overflow: hidden;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
    }

    .ranking-box-hd {
        display: flex;
        position: relative;

        >div {
            // width: 50%;
            line-height: 100px;
            // font-size: 36px;
            font-weight: 500;
            text-align: center;
            color: #999999;
            padding: 0 15px;
            // background-color: #F5F5F5;

            &.on {
                position: relative;
                color: #333333;

                &::before {
                    position: absolute;
                    content: '';
                    left: 50%;
                    bottom: 20px;
                    width: 40px;
                    height: 6px;
                    transform: translate(-50%);
                    background-color: #333333;
                    border-radius: 4px;
                }
            }
        }
    }

    .tabs-box {
        padding: 0 30px;
    }

    .job-tabs {
        // display: flex;
        margin: 40px 0 10px 0;

        >div {
            display: flex;
            justify-content: space-around;
        }

        .group-tabs {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 50px;
        }
    }

    .job-tab-item {
        color: #999999;
        font-size: 30px;
        margin: 10px 0px 40px 0;
        font-weight: 500;
        text-align: center;
        border-radius: 30PX;
        position: relative;

        &.on {
            color: #333333;

            // background-color: #DAA55F;
            // color: #ffffff;
            &::before {
                position: absolute;
                content: '';
                left: 50%;
                bottom: -15px;
                width: 40px;
                height: 6px;
                transform: translate(-50%);
                background-color: #333333;
                border-radius: 4px;
            }
        }
    }



    .group-tab-item {
        min-width: 22%;
        // margin-right: 30px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;
        padding: 3px 10px;
        margin-right: 23px;

        &.on {
            color: #ffffff;
            background-color: #DBC7C1;
        }
    }

    .ranking-list-box {
        border-top: 2px solid #eeeeee;
    }

    .ranking-list-item-box {
        padding: 0 20px;
    }

    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }
    }

    .ranking-num {
        width: 60px;
        margin-right: 40px;

        .color-red {
            color: #AB080B;
        }

        >img {
            width: 50px;
            height: 60px;
        }
    }

    .ranking-name {
        display: flex;
        align-items: center;
        width: 240px;

        >.img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
        }

    }

    .ranking-order {
        width: 160px;
        text-align: center;
    }

    .ranking-bonus {
        width: 180px;
        text-align: center;
    }



    .popup-rule {
        width: 650px;
        padding-bottom: 30px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
    }

    .popup-rule-hd {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 120px;
        font-size: 36px;
        font-weight: 500;
        background-image: linear-gradient(#CEDBF0, #ffffff);
    }

    .popup-main {
        height: 600px;
        overflow-y: scroll;

        >.title {
            padding: 20px 40px;
            font-size: 28px;
            font-weight: 500;
        }

        >.describe {
            padding: 0 60px;
            font-style: 24px;
            color: #66757F;
            line-height: 46px;
        }
    }

    .popup-close {
        position: absolute;
        left: 50%;
        bottom: -90px;
        transform: translate(-50%);
    }

    .bg-color {
        height: 90px;
        margin: -30px 0;
        background-color: #E9E9E9;
    }

    .cityWrapper {
        padding: 20px 0;

        .cityBox {
            display: flex;
            align-items: center;

            .position {
                width: 23px;
                height: 28px;
                margin-left: 20px;
            }

            .arrow {
                width: 10px;
                height: 18px;
            }

            >span {
                padding: 0 15px;
            }
        }
    }
</style>
<style lang="less">
    .ranking {
        .red {
            color: #D41D16;
            font-weight: 500;
        }

        .van-popup {
            overflow-y: visible;
        }

        .van-image__error {
            background-color: #A1A1A1;
        }

        .van-list__finished-text,
        .van-list__loading,
        .van-list__error-text {
            margin-top: -2px;
            background-color: #fff;
        }
    }

    p {
        margin: 0;
    }
</style>
